import { projectPermission } from '@/middleware/permission';

export default [
  // {
  //   path: "/setting",
  //   name: "setting",
  //   component:()=> setting,
  //   meta: { type: "setting" },
  // },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/setting/Setting.vue'),
    meta: { type: 'setting',middleware: [projectPermission] },
  },
  {
    path: '/settings/integrations',
    name: 'settingsIntegrations',
    component: () => import('@/views/setting/Integrations.vue'),
    meta: { type: 'setting' },
  },
];
